<template>
  <div>
    <b-navbar toggleable="lg" class="primary-violet-bg">
      <b-navbar-brand href="/"
        ><img src="../assets/logo.png" :alt="siteTitle" class="logo"
      /></b-navbar-brand>

      <div class="extra-menu-items">
        <ul class="list-inline">
          <li class="list-inline-item"><a href="/search" class="search"><i class="fa fa-search fa-lg"></i></a></li>
          <li class="list-inline-item"><a href="/store" class="btn btn-sm online-store">Online Store</a></li>
        </ul>
      </div>
      <b-navbar-toggle target="nav-collapse" class="p-1">
        <template #default="{ expanded }">
          <i
            v-if="expanded"
            class="fa fa-times text-medium tertiary-violet"
          ></i>
          <i v-else class="fa fa-bars fa-lg fa-stretch tertiary-violet"></i>
        </template>
      </b-navbar-toggle>
    </b-navbar>
    <div class="mobile-menu">
      <b-collapse id="nav-collapse" class="mobile-menu-items text-right" is-nav>
        <b-navbar-nav>
          <b-nav-item
            class="text-uppercase font-weight-bold"
            v-for="(menuItem, index) in menuItems"
            :key="index"
            :href="index"
            >{{ menuItem }}</b-nav-item
          >
          <div class="text-center social-media-links" style="">
            <ul class="list-inline">
              <li class="list-inline-item">
                <a href="#">
                  <span class="fa-stack">
                    <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
                    <i class="fab fa-instagram fa-stack-1x"></i>
                  </span>
                </a>
                <a href="#">
                  <span class="fa-stack">
                    <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
                    <i class="fab fa-facebook-f fa-stack-1x"></i>
                  </span>
                </a>
                <a href="#">
                  <span class="fa-stack">
                    <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
                    <i class="fab fa-twitter fa-stack-1x"></i>
                  </span>
                </a>
              </li>
              <li class="list-inline-item"></li>
              <li class="list-inline-item"></li>
            </ul>
          </div>
        </b-navbar-nav>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import axios from "axios";

const localStorageKey = "menuItems";

export default {
  name: "MobileNavigation",
  data() {
    return {
      siteTitle: "Dutche Chocolates",
      menuItems: undefined
    };
  },
  mounted() {
    const menuItems = this.getMenuItems();

    if (menuItems !== null) {
      this.menuItems = menuItems;
      return;
    }

    axios.get("/menu-items").then(response => {
      this.saveMenuItems(response.data);
      this.menuItems = JSON.parse(JSON.stringify(response.data));
    });
  },
  methods: {
    saveMenuItems(value) {
      const now = new Date();
      const timeToLive = 3 * 60 * 60 * 1000; // defaults to 3 hours
      const item = {
        value: value,
        expiration: now.getTime() + timeToLive
      };

      localStorage.setItem(localStorageKey, JSON.stringify(item));
    },

    getMenuItems() {
      const menuItems = localStorage.getItem(localStorageKey);

      if (!menuItems) {
        return null;
      }

      const item = JSON.parse(menuItems);
      const now = new Date();

      if (now.getTime() > item.expiration) {
        localStorage.removeItem(localStorageKey);
        return null;
      }

      return item.value;
    }
  }
};
</script>

<style lang="sass" scoped>
.primary-violet-bg
  background-color: $dutche-primary-violet

.logo
  height: auto
  width: 5rem

.text-medium
  font-size: 1.5rem

.tertiary-violet
  color: $dutche-tertiary-violet

.mobile-menu
  position: relative

.mobile-menu-items
  top: 0
  z-index: 100
  background-color: $white
  width: 40%
  font-weight: bold

.navbar
  justify-content: space-between

.navbar-collapse
  position: absolute
  left: 100%
  transition: all 0.5s ease
  transform: translateZ(0)
  display: block

.navbar-collapse.collapsing
  height: auto !important
  margin-right: 50%
  transition: all 0.5s ease
  transform: translateZ(0)
  display: block

.navbar-collapse.show
  left: calc( 60% - 35% )
  width: 75%
  height: auto
  min-height: 95vh
  overflow-x: hidden
  padding-top: 5.125rem
  margin-top: -5.125rem

.nav-link
  color: $dutche-primary-violet
  padding-right: 0.5rem

.navbar-nav
  .nav-item
    border-bottom: 1px solid $dutche-senary-violet
    padding: 0.75rem 3rem
  
  .nav-item:last-child
    border-bottom: none

  .nav-item:hover
    background-color: $dutche-primary-yellow
  
  .social-media-links
    font-size: 1.5em
    margin-top: 20vh
    padding-bottom: 3rem

    a
      color: $dutche-primary-violet

    a:hover
      color: $dutche-primary-orange

    .fas
      color: $dutche-secondary-yellow

.extra-menu-items
  margin-right: 0.6rem
  z-index: 101
  align-items: center
  justify-content: center
  display: flex

  .online-store
    background-color: $dutche-primary-yellow
    border: 1px solid $dutche-primary-yellow
    color: $dutche-primary-violet
    text-transform: uppercase
    font-weight: bolder
    font-size: 0.7rem

  .search
    color: $dutche-tertiary-violet
  
.navbar-light 
  .navbar-toggler
    z-index: 200
    color: transparent
    border-color: transparent    

.fa-stretch
  transform: scale(1.25,1)  

.list-inline
  margin-bottom: 0

.navbar-brand
  flex: auto
</style>
<style lang="sass">
  
</style>
